import React from 'react';
import Select, { components } from 'react-select';
import "./SelectWalletsCoin.css"

const { Option, SingleValue } = components;

const IconOption = (props) => (
  <Option style={{display: 'flex', alignItems: 'center', flexDirection: 'row'}} {...props}>
    {
      props.data && props.data.symbol && props.data.symbol !== "" &&
      <img
        src={require('../../CryptoIcons/' + props.data.symbol + '.svg')}
        style={{ width: "20px", marginRight: '4px'}}
        alt={props.data.name}
      />
    }
    <div style={{color: "#2E2C2C", width: "100%", display: "flex", justifyContent: "space-between"}}>{props.data.name} <span style={{color: "#909090"}}>{props.data.symbol.toUpperCase()}</span></div>
  </Option>
);

const ValueOption = (props) => (
  <SingleValue style={{display: 'flex', alignItems: 'center', flexDirection: 'row'}} {...props}>
    {
      props.data && props.data.symbol && props.data.symbol !== "" &&
      <img
        src={require('../../CryptoIcons/' + props.data.symbol + '.svg')}
        style={{ width: "20px", marginRight: '4px'}}
        alt={props.data.name} 
      />
    }
    <div style={{color: "#2E2C2C", width: "100%"}}>{props.data.name} <span style={{color: "#909090"}}>{props.data.symbol.toUpperCase()}</span></div>
  </SingleValue>
);

const SelectWalletCoins = ({
  onChange,
  value,
  options,
  placeholder = "",
}) => {

  return (
    <Select
      id="select-wallet-coins"
      value={value}
      options={options}
      onChange={onChange}
      placeholder={placeholder}
      isMulti={false}
      isSearchable={false}
      isClearable={false}
      components={{ Option: IconOption, SingleValue : ValueOption }}
    />
  )
}

export default SelectWalletCoins;